import React from 'react';
import { UrgencyBar } from '../components/UrgencyBar';
import { Hero } from '../components/Hero';
import { PainPoints } from '../components/PainPoints';
import { Revelation } from '../components/Revelation';
import { ProductModules } from '../components/ProductModules';
import { PricingTable } from '../components/PricingTable';
import { Testimonials } from '../components/Testimonials';
import { Guarantee } from '../components/Guarantee';
import { FAQ } from '../components/FAQ';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <div className="min-h-screen w-full bg-cream" data-id="element-337">
      <UrgencyBar data-id="element-338" />

      <main data-id="element-339">
        <Hero data-id="element-340" />
        <PainPoints data-id="element-341" />
        <Revelation data-id="element-342" />
        <ProductModules data-id="element-343" />
        <PricingTable data-id="element-344" />
        <Testimonials data-id="element-345" />
        <Guarantee data-id="element-346" />
        <FAQ data-id="element-347" />
        <CTASection data-id="element-348" />
      </main>

      <Footer data-id="element-349" />
    </div>;
}